import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Tab from './AdminsTab';
import Form from './AdminForm';

function AdminsRouter() {
  return (
    <Switch>
      <Route exact path="/admins" component={Tab} />
      <Route exact path="/admins/new" component={Form} />
      <Route exact path="/admins/:id" component={Form} />
      <Redirect to="/admins" />
    </Switch>
  );
}

export default AdminsRouter;



// WEBPACK FOOTER //
// ./src/containers/Admins/index.js